import { colors } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";

import { DestinationConfigRow } from "../shared/ConfigPageRow";

const CredentialsModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
}) => {
  const mixpanel = useSelector((state) => state.destinations.data.mixpanel);
  const { settings: allSettings } = mixpanel;

  return (
    <ConfigureDestinationsModal
      limitSettings={["token", "secret"]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
    />
  );
};

const CredentialsRow = ({ setConfigModalOpen }) => {
  const config = useSelector(
    (state) => state.destinations.data.mixpanel.settings
  );
  const idSet = !!config.token;

  return (
    <DestinationConfigRow
      name="Credentials"
      labelColor={idSet ? colors.green[600] : colors.red[600]}
      labelText={idSet ? "Configured" : "Not Configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
}) => {
  const allSettings = useSelector(
    (state) => state.destinations.data.mixpanel.settings
  );

  return (
    <ConfigureDestinationsModal
      limitSettings={[
        "groupIdentifierTrait",
        "ip",
        "crossSubdomainCookie",
        "consolidatedPageCalls",
        "enableEuropeanUnionEndpoint",
        "secureCookie",
        "ignore_dnt",
      ]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen }) => {
  const config = useSelector(
    (state) => state.destinations.data.mixpanel.settings
  );
  const enabled = !!config.token;

  return (
    <DestinationConfigRow
      disabled={!enabled}
      name="Options"
      labelColor={colors.grey[400]}
      labelText={enabled ? "Optional" : null}
      onOpenConfigModal={() => {
        if (enabled) {
          setConfigModalOpen();
        }
      }}
    />
  );
};

const CREDENTIALS = "CREDENTIALS";
const OPTIONS = "OPTIONS";

const Rows = {
  CREDENTIALS: CredentialsRow,
  OPTIONS: ConfigurationRow,
};

const Modals = {
  CREDENTIALS: CredentialsModal,
  OPTIONS: ConfigurationModal,
};

const RowOrder = [CREDENTIALS, OPTIONS];

export default {
  Rows,
  RowOrder,
  Modals,
};
